import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import './modalmov.css';
import { Sell } from '../../domain/models/Sell';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { ModalMovActions } from '../../presentation/redux/actions/ModalMovActions';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { ModalMovActionButtons } from './ModalMovActionButtons';
import { ModalMovCustom } from './ModalMovCustom';
import { moneyFormat } from '../../presentation/utils/moneyFormat';



export function ModalMovements() {

    const modalState = useSelector((s: RootState) => s.modalMovState);
    const uiState = useSelector((s: RootState) => s.uiState);
    const dispatch = useDispatch();

    function onHide() {
        dispatch(UIActions.closeModalMov());
        dispatch(ModalMovActions.reset());
    }

    const size = modalState.isCustom ? "lg" : "lg"
    return (
        <Modal
            show={uiState.isModalMovOpen}
            onHide={onHide}
            backdrop="static"
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton
                className='gradientBlue colorWhite'>
                <Modal.Title id="contained-modal-title-vcenter">
                    {modalState.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='bg-light' style={{ minHeight: 420 }}>

                {
                    !modalState.isCustom && <ModalMovActionButtons />
                }

                {modalState.isCustom ? <ModalMovCustom />
                    : <React.Fragment>
                        {modalState.isResume ?
                            <Table bordered hover className="table table-striped table-responsive">
                                <thead>
                                    <tr>
                                        <th style={{ width: '1%' }}>Fecha y hora</th>
                                        <th style={{ width: '1%' }}>ID</th>
                                        <th style={{ width: '1%' }}>Descripción</th>
                                        <th style={{ width: '1%' }}>Origen</th>
                                        <th style={{ width: '1%' }}>Destino</th>
                                        <th style={{ width: '1%' }}>Monto</th>
                                        <th style={{ width: '1%' }}>Referencia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modalState.data && modalState.data.length === 0 && <tr><td colSpan={6}><h5 style={{ marginTop: 10, color: '#888' }}>No hay datos para mostrar.</h5></td></tr>}
                                    {modalState.data && modalState.data.map((item: Sell) => {
                                        return (<tr key={item.operation_id}>
                                            <td>{item.date_hour}</td>
                                            <td>{item.operation_id}</td>
                                            <td>{item.description}</td>
                                            <td>{item.origin}</td>
                                            <td>{item.destination}</td>
                                            <td>{moneyFormat(item.amount)}</td>
                                            <td>{item.reference}</td>
                                        </tr>)
                                    }
                                    )}
                                </tbody>
                            </Table>
                            : <Table bordered hover className="table table-striped table-responsive">
                                <thead>
                                    <tr>
                                        <th style={{ width: '1%' }}>Fecha y hora</th>
                                        <th style={{ width: '1%' }}>SKU</th>
                                        <th style={{ width: '1%' }}>Proveedor</th>
                                        <th style={{ width: '1%' }}>Descripción</th>
                                        <th style={{ width: '1%' }}>Monto</th>
                                        <th style={{ width: '1%' }}>Comisión</th>
                                        <th style={{ width: '1%' }}>Destino</th>
                                        <th style={{ width: '1%' }}>Confirmación</th>
                                        <th style={{ width: '1%' }}>Usuario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modalState.data && modalState.data.length === 0 && <tr><td colSpan={8}><h5 style={{ marginTop: 10, color: '#888' }}>No hay datos para mostrar.</h5></td></tr>}
                                    {modalState.data && modalState.data.map((item: Sell) => <tr key={item.confirmation}>
                                        <td>{item.date_hour}</td>
                                        <td>{item.sku}</td>
                                        <td>{item.carrier}</td>
                                        <td>{item.description}</td>
                                        <td>{moneyFormat(item.amount)}</td>
                                        <td>{item.comision}</td>
                                        <td>{item.destination}</td>
                                        <td>{item.confirmation}</td>
                                        <td>{item.uid ?? '-'}</td>
                                    </tr>)}
                                </tbody>
                            </Table>}
                    </React.Fragment>}
            </Modal.Body>
            <Modal.Footer className='bg-light'>
                {modalState.isCustom && <Button disabled={false} onClick={() => {
                    dispatch(ModalMovActions.getData(modalState));
                }}>Consultar</Button>}
                {
                    !modalState.isCustom && <ModalMovActionButtons inverted={true} />
                }
            </Modal.Footer>
        </Modal>
    );
}